import { useWalletsSearchFilters } from './usePageParams';
import { WalletKeys } from 'api/types/httpsTypes/contracts';
import {
  PresetButton,
  PresetButtonDescription,
  PresetButtonTitle,
} from '../TelegramCalls/PresetButton';
import { chainName } from  'api/types/httpsTypes/d-wallets';
import Button from 'modules/shared-components/button/button';
import CustomModal from '../../../components/modal/CustomModal';
import { useSelectedChain } from '../../../components/chains/getChains';

type Props = {
  handleClose: () => void;
};

export function capitalizeFirstLetter(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function LabelsFilterModal({ handleClose }: Props) {
  const { filtersState, setFilters } = useWalletsSearchFilters();
  const chain = useSelectedChain();
  const tradingStyle = filtersState.tradingStyle;

  return (
    <CustomModal title="Wallet Labels" handleClose={handleClose} showModal>
      <CustomModal.Body className="xxs:p-4">
        <CustomModal.Title className="hidden lg:flex">
          Wallet Labels
        </CustomModal.Title>

        <CustomModal.Content>
          <div className="xxs:space-y-3">
            <p className="xxs:text-sm xxs:mb-0">
              Mizar's advanced AI analyzes swaps in real time, labeling wallets
              based on their performance. There are 4 main labels:
            </p>
            <ul>
              <li>📄 Best To Copy: The top wallets to copy-trade.</li>
              <li>
                🎯 Top Sniper: top 10% based on total profit from tokens sniped
                within a maximum of 1 hour after launc.
              </li>
              <li>
                🐒 Early Ape: top 10% based on total profit from tokens traded
                between a maximum of 1 hour and 2 weeks after launch.
              </li>
              <li>
                📈 Top Trader: top 10% based on total profit from tokens traded
                after a minimum of 2 weeks after launch.
              </li>
            </ul>
            <div className="xxs:space-y-1">
              <div className="flex flex-col xxs:space-y-1 xxs:mb-4 w-full">
                <PresetButton
                  className={
                    tradingStyle === WalletKeys.TopCopy
                      ? 'xxs:bg-dex-black-600 xxs:text-dex-white'
                      : ''
                  }
                  onClick={() => {
                    setFilters({
                      ...filtersState,
                      tradingStyle: WalletKeys.TopCopy,
                    });
                    handleClose();
                  }}
                >
                  <PresetButtonTitle>📄 Best To Copy</PresetButtonTitle>
                  <PresetButtonDescription>
                    The best wallets to copy-trade on {chainName(chain)}
                  </PresetButtonDescription>
                </PresetButton>

                <PresetButton
                  className={
                    tradingStyle === WalletKeys.TopSniper
                      ? 'xxs:bg-dex-black-600 xxs:text-dex-white'
                      : ''
                  }
                  onClick={() => {
                    setFilters({
                      ...filtersState,
                      tradingStyle: WalletKeys.TopSniper,
                    });
                    handleClose();
                  }}
                >
                  <PresetButtonTitle>🎯 Top Sniper</PresetButtonTitle>
                  <PresetButtonDescription>
                    The top 10% snipers on {chainName(chain)}
                  </PresetButtonDescription>
                </PresetButton>
                <PresetButton
                  className={
                    tradingStyle === WalletKeys.EarlyApe
                      ? 'xxs:bg-dex-black-600 xxs:text-dex-white'
                      : ''
                  }
                  onClick={() => {
                    setFilters({
                      ...filtersState,
                      tradingStyle: WalletKeys.EarlyApe,
                    });
                    handleClose();
                  }}
                >
                  <PresetButtonTitle>🐒 Early Ape</PresetButtonTitle>
                  <PresetButtonDescription>
                    The top 10% early apes on {chainName(chain)}
                  </PresetButtonDescription>
                </PresetButton>
                <PresetButton
                  className={
                    tradingStyle === WalletKeys.Trader
                      ? 'xxs:bg-dex-black-600 xxs:text-dex-white'
                      : ''
                  }
                  onClick={() => {
                    setFilters({
                      ...filtersState,
                      tradingStyle: WalletKeys.Trader,
                    });
                    handleClose();
                  }}
                >
                  <PresetButtonTitle>📈 Top Trader</PresetButtonTitle>
                  <PresetButtonDescription>
                    The top 10% traders on {chainName(chain)}
                  </PresetButtonDescription>
                </PresetButton>
              </div>
            </div>
          </div>
        </CustomModal.Content>
      </CustomModal.Body>
      <CustomModal.Footer>
        <Button
          type="button"
          variant="dexNeutral"
          onClick={() => handleClose()}
        >
          Close
        </Button>
      </CustomModal.Footer>
    </CustomModal>
  );
}
